<template>
  <Select ref="select"
          v-model="search.value"
          :placeholder="'请选择' + search.label"
          filterable
          @on-change="emitSearchQuery">
    <Option value="">请选择</Option>
    <template v-for="item in options">
      <Option v-if="Array.isArray(item)"
          :value="item[0]"
          :key="item[0]">{{ item[1] }}</Option>
      <Option v-else
              :value="item.value"
              :key="item.id || item.value">{{ item.label }}</Option>
    </template>

  </Select>
</template>

<script>
export default {
  props: {
    search: {
      type: Object
    }
  },
  data () {
    return {
      options: []
    }
  },
  created () {
    // this.search.value = this.search.value || '';

    if (!this.search.componentAttr) {
      if (this.search.request) {
        this.fetchOptionList();
      }
    } else {
      this.options = this.search.componentAttr.options || [];
    }
  },
  watch: {
    'search.value': {
      handler (val) {
        if (typeof val !== 'number' && !val) {
          this.$refs['select'].setQuery(null);
        }
      }
    }
  },
  methods: {
    emitSearchQuery (item) {
      const _self = this;
      // if (item) {
      // 将值往上传
      _self.$emit('getSearchValueChange', _self.search);
      _self.$emit('enter');
      // }
    },
    fetchOptionList () {
      const _self = this;
      _self[_self.search.request.method](_self.search.request.addr, _self.search.request.data).then(res => {
        if (_self.search.request.format) {
          _self.options = [];
          let result = res.data;
          if (Array.isArray(result.list)) {
            result = result.list;
          }
          for (let item of result) {
            if (typeof _self.search.request.format.label === 'string') {
              _self.options.push({
                id: item.id,
                value: item[_self.search.request.format.value],
                label: item[_self.search.request.format.label]
              });
            } else {
              let label = '';
              for (let l of _self.search.request.format.label) {
                label += '-' + item[l]
              }
              label = label.substr(1);
              _self.options.push({
                id: item.id,
                value: item[_self.search.request.format.value],
                label: label
              });
            }
          }
        } else {
          _self.options = res.data;
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/regularQuery/select.vue